import {
    Dialog,
    ScreenMessagePanelContainer,
    Label,
    ButtonLight,
    ButtonStandard,
    ComboBox,
    formatMessage,
    RadioButton,
    Flexbox,
} from 'cw-ui-core';
import css from './ManageApplicationDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React, { useState } from 'react';

export const MANAGE_APPLICATION_USER_DIALOG = 'MANAGE_APPLICATION_USER_DIALOG';

const ManageApplicationDialog = props => {
    const [applicationValue, setApplicationValue] = useState('');
    const setApplication = filter => {
        setApplicationValue(filter.id);
        props.setValueOnPath('applicationSelected', filter.id);
    };

    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={props.onCancel}
        />,
        <ButtonStandard
            key="apply"
            automationName="apply"
            className={css.applyButton}
            value={formatMessage(Locale.apply)}
            onClick={props.onApply}
            disabled={!(props.option !== undefined && applicationValue !== '')}
        />,
    ];

    return (
        <Dialog
            dialogId={MANAGE_APPLICATION_USER_DIALOG}
            header={formatMessage(Locale.updateApplicationDialogHeader)}
            buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer
                        className={css.screenMessage}
                        screenKey={MANAGE_APPLICATION_USER_DIALOG}
                    />
                    <Label value={formatMessage(Locale.updateApplicationDialogDescription)} />
                    <Flexbox className={css.radioButtonsContainer}>
                        <RadioButton
                            automationName="addApplicationRadioButton"
                            value={{
                                id: props.manageApplication[0].id,
                                name: props.manageApplication[0].name,
                                checked: props.option === props.manageApplication[0].id,
                            }}
                            onChange={props.onChangeOption}
                        />
                        <RadioButton
                            automationName="removeApplicationRadioButton"
                            value={{
                                id: props.manageApplication[1].id,
                                name: props.manageApplication[1].name,
                                checked: props.option === props.manageApplication[1].id,
                            }}
                            onChange={props.onChangeOption}
                        />
                    </Flexbox>

                    <ComboBox
                        cwId="productsDropDown"
                        automationName="productsDropDown"
                        items={props.productsList}
                        expandOnClick
                        readOnly
                        value={applicationValue}
                        onChange={filter => setApplication(filter)}
                        placeholder={formatMessage(Locale.selectApplication)}
                        className={css.applicationDropdown}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default ManageApplicationDialog;
